import { omit } from "lodash";
import { FunctionComponent, ReactNode } from "react";
import styled from "styled-components";
import { Flex } from "../../../../components/layout";
import { WIDGET_BORDER_RADIUS } from "../../../../components/widget";
import {
  TextWidget,
  TextWidgetProps
} from "../../../../components/widget/text-widget";
import { device } from "../../../../styles/media";

export const StyledTextWidget = styled(TextWidget)`
  padding: 1em;
  border-radius: ${WIDGET_BORDER_RADIUS};

  @media ${device.laptop} {
    padding: 2em;
  }
`;

interface ITileProps {
  cta?: ReactNode;
}

export const Amount = styled(Flex).attrs({ center: true })<{
  hasTopMargin: boolean;
}>`
  width: 100%;
  margin: ${(props) => (props.hasTopMargin ? "0.8em 0" : "0")};
  font-size: 3em;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Tile: FunctionComponent<ITileProps & TextWidgetProps> = (props) => {
  const { children, cta, title } = props;

  return (
    <StyledTextWidget {...omit(props, "children", "cta")}>
      <Amount hasTopMargin={!!title}>{children}</Amount>
      {cta || null}
    </StyledTextWidget>
  );
};

export default Tile;
